import { render } from "./VerifDoneHistory.vue?vue&type=template&id=54b968e0&scoped=true"
import script from "./VerifDoneHistory.vue?vue&type=script&lang=js"
export * from "./VerifDoneHistory.vue?vue&type=script&lang=js"

import "./VerifDoneHistory.vue?vue&type=style&index=0&id=54b968e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b968e0"]])

export default __exports__